<template>
    <div class="orderorder">
        <!-- 单据功能按钮 -->
        <div
            style="display: flex; align-items: center; justify-content: space-between; padding: 0 10px; box-sizing: border-box">
            <div style="display: flex; align-items: center">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('1')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('2')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('3')"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('4')"
                />
            </div>
            <div style="float: right">
                <el-button type="primary" :disabled="isAdd || !isedit || !isedit || nullBtn" @click="labelClick"
                           style="margin-right: 10px">
                    {{ $t('common.diyLabel') }}
                </el-button>

                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    :disabled="isAdd || !isedit"
                    @click="add"
                    v-if="perData.allow_add == 1"
                >{{ $t('common.add') }}
                </el-button
                >
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                >{{ $t('common.edit') }}
                </el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="delOrder"
                    v-if="perData.allow_dele == 1"
                >{{ $t('common.delete') }}
                </el-button
                >
                <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill')
                    }}
                </el-button>
                <el-button type="primary" :disabled="isAdd || !isedit || nullBtn" plain @click="Check(form.check)">{{
                        form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                    }}
                </el-button>
            </div>
        </div>
        <!-- 单据操作信息 -->
        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="2">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span
                        :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited')
                        }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditTime') }}<span>{{ form.check_date }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 主表表单 -->
        <div class="top_cols" style="padding-bottom: 0">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billNo') + '：'" label-width="180">
                            <el-input v-model="form.bill_no" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billDate') + '：'" label-width="180" required>
                            <el-date-picker
                                type="datetime"
                                :disabled="isedit"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期"
                                v-model="form.bill_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.billType') + '：'" required>
                                <mySelect
                                    v-model="form.billtype_no"
                                    :options="allArr.billtype"
                                    values="billtype_no"
                                    labels="billtype_name"
                                    keys="billtype_no"
                                    :disable="isedit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="成品柜台：" label-width="180" required>
                            <mySelect
                                v-model="form.product_counter_no"
                                :options="allArr.counter"
                                values="counter_no"
                                labels="counter_name"
                                keys="counter_no"
                                :disable="isedit"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="物料柜台：" label-width="180" required>
                            <mySelect
                                v-model="form.bom_counter_no"
                                :options="allArr.counter"
                                values="counter_no"
                                labels="counter_name"
                                keys="counter_no"
                                :disable="isedit"
                                @selectChange="onBomCounterChange"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.handler') + '：'" label-width="180">
                            <mySelect
                                v-model="form.staff_no"
                                :options="allArr.staff"
                                values="staff_no"
                                labels="staff_name"
                                keys="staff_no"
                                :disable="isedit"
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="4" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isedit"
                                    :clearables="false"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="systemSet.isstores == 1 ? 12 : 16">
                        <el-form-item label-width="200" :label="$t('common.remark') + '：'">
                            <el-input type="textarea" :rows="1" v-model="form.remark" :disabled="isedit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!-- 组装编辑区与明细标签页 -->
        <div class="assembly_body">
            <!-- 左侧：成品数据 + 物料数据（上下布局，高度五五开） -->
            <div class="assembly_left">
                <!-- 成品数据 From 表单 -->
                <div class="table1 product_panel">
                    <div class="title">
                        <p>成品数据</p>
                        <div>
                            <!-- 默认按钮组：新增、修改、删除（不限权限，仅单据新增/编辑状态可用） -->
                            <template v-if="!productFormEditable">
                                <el-button size="mini" type="primary" :disabled="isedit" @click="newAssembly">新增
                                </el-button>
                                <el-button size="mini" type="warning" :disabled="isedit || !editingDtlRow"
                                           @click="editAssembly">修改
                                </el-button>
                                <el-button size="mini" type="danger"
                                           :disabled="isedit || !editingDtlRow || productFormEditable"
                                           @click="deleteProductDtl">删除
                                </el-button>
                            </template>
                            <!-- 编辑状态按钮组：保存、取消 -->
                            <template v-else>
                                <el-button size="mini" type="success" @click="addAssembly">保存</el-button>
                                <el-button size="mini" type="info" @click="cancelEditAssembly">取消</el-button>
                            </template>
                            <el-button type="" :disabled="isedit" @click="showImpotDialog = true">导入</el-button>
                        </div>
                    </div>
                    <el-form :model="productForm" class="product_form" label-width="150px" size="mini">
                        <el-row :gutter="10">
                            <el-col :span="8" v-for="(item, index) in productShowKeyList" :key="item.field + index">
                                <el-form-item :label="item.column_name">
                                    <el-select
                                        v-if="item.column_type == 'select'"
                                        v-model="productForm[item.field]"
                                        filterable
                                        default-first-option
                                        placeholder="请选择"
                                        :disabled="item.column_disabled == 1 || isedit || !productFormEditable"
                                        @change="changeProductData(item.field.replace('_no', ''))"
                                    >
                                        <el-option
                                            v-for="option in allArr[item.field.replace('_no', '')] || []"
                                            :key="option[item.field.replace('_no', '') + '_no']"
                                            :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                                option[item.field.replace('_no', '') + '_name']
                                            }`"
                                            :value="option[item.field.replace('_no', '') + '_no']"
                                            :disabled="option.status == 0"
                                        ></el-option>
                                    </el-select>
                                    <el-input
                                        v-else
                                        v-model="productForm[item.field]"
                                        :disabled="
                                            item.column_disabled == 1 ||
                                            isedit ||
                                            !productFormEditable ||
                                            item.field == 'product_seq'
                                        "
                                        @input="handleProductInput(item.field, item.column_type)"
                                        @blur="item.column_type == 'number' ? $vaildator.all(productForm, item.tofixed, item.field) : ''"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- 物料数据表格（不需要计算） -->
                <div class="table1 material_panel" @mouseleave="dtlleave">
                    <div class="title">
                        <p>物料数据</p>
                    </div>
                    <vxe-table
                        border
                        stripe
                        resizable
                        keep-source
                        align="center"
                        ref="xTable1"
                        :height="materialHeight"
                        show-overflow
                        show-header-overflow
                        highlight-hover-row
                        :loading="loading"
                        :keyboard-config="{ isArrow: true, isDel: true, isedit: true }"
                        :row-class-name="rowChange"
                        :data="materialList"
                        :mouse-config="{ selected: true }"
                        :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                        @cell-mouseenter="dtlenter"
                        :key="refushTable"
                        :scroll-y="{ enabled: true, gt: 50 }"
                    >
                        <vxe-table-column type="seq" field="seq" width="70" title="序号">
                            <template slot="header">
                                <i class="el-icon-setting" @click.stop="isedit ? changeTable('142') : null"></i>
                            </template>
                            <template slot-scope="scoped">
                                <span class="add_" v-if="scoped.$rowIndex == dtlIndex && !isedit && productFormEditable">
                                    <i class="el-icon-circle-plus-outline" @click="adddtl"></i>
                                    <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
                                </span>
                                <span v-if="scoped.$rowIndex != dtlIndex">
                                    <i style="font-style: normal">{{ scoped.seq }}</i>
                                </span>
                            </template>
                        </vxe-table-column>

                        <template v-for="(item, index) in materialKeyList">
                            <vxe-table-column
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                                :edit-render="{
                                    name: 'input',
                                    attrs: { type: item.column_type },
                                    autoselect: true,
                                    autofocus: '.vxe-input--inner'
                                }"
                                v-if="item.column_status == 1 && item.column_type != 'select'"
                            >
                                <template v-slot:edit="{ row }">
                                    <vxe-input
                                        type="text"
                                        @input="handleInput(row, item.field, item.column_type, 'materialTable')"
                                        @keydown.native="jumptable($event, row, item.field)"
                                        v-model="row[item.field]"
                                        @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                        :disabled="item.column_disabled == 1"
                                    ></vxe-input>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column
                                v-if="item.column_status == 1 && item.column_type == 'select'"
                                :title="item.column_name"
                                :field="item.field"
                                :width="item.column_width"
                                :key="item.field + index"
                                :edit-render="{ autofocus: '.el-input__inner' }"
                            >
                                <template #default="{ row }">
                                    <span>{{
                                            $selectLable.selectLable(
                                                row[item.field],
                                                allArr[item.field.replace('_no', '')],
                                                item.field,
                                                item.field.replace('_no', '_name')
                                            )
                                        }}</span>
                                </template>
                                <template v-slot:edit="{ row }">
                                    <el-select
                                        size="mini"
                                        v-model="row[item.field]"
                                        ref="stylefocus"
                                        filterable
                                        default-first-option
                                        placeholder="请选择"
                                        @change="changeData(row, item.field.replace('_no', ''))"
                                        @keydown.native="jumptable($event, row, item.field)"
                                    >
                                        <el-option
                                            v-for="option in allArr[item.field.replace('_no', '')] || []"
                                            :key="option[item.field.replace('_no', '') + '_no']"
                                            :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                                option[item.field.replace('_no', '') + '_name']
                                            }`"
                                            :value="option[item.field.replace('_no', '') + '_no']"
                                            :disabled="option.status == 0"
                                        ></el-option>
                                    </el-select>
                                </template>
                            </vxe-table-column>
                        </template>

                        <template #empty>
                            <span style="color: red">
                                <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                            </span>
                        </template>
                    </vxe-table>
                </div>
            </div>
            <!-- 右侧：成品明细/物料明细 tabs（只读） -->
            <div class="assembly_right">
                <el-tabs v-model="activeTab" type="border-card" class="dtl_tabs" @tab-click="onDetailTabClick">
                    <el-tab-pane label="成品明细" name="productDtl">
                        <vxe-table
                            border
                            stripe
                            resizable
                            align="center"
                            ref="productDtlTable"
                            :height="detailTableHeight"
                            show-overflow
                            show-header-overflow
                            highlight-hover-row
                            :data="form.productDtl"
                            :row-class-name="rowChange"
                            :key="refushTable"
                            :scroll-y="{ enabled: true, gt: 50 }"
                            @cell-click="productDtlRowClick"
                        >
                            <vxe-table-column type="checkbox" width="50"></vxe-table-column>

                            <vxe-table-column type="seq" field="seq" width="70" title="序号">
                                <template slot="header">
                                    <i class="el-icon-setting" @click.stop="isedit ? changeTable('141') : null"></i>
                                </template>
                                <template slot-scope="scoped">
                                    <span><i style="font-style: normal">{{ scoped.seq }}</i></span>
                                </template>
                            </vxe-table-column>

                            <template v-for="(item, index) in productKeyList">
                                <vxe-table-column
                                    v-if="item.column_status == 1 && item.column_type != 'select'"
                                    :title="item.column_name"
                                    :field="item.field"
                                    :width="item.column_width"
                                    :key="item.field + index"
                                >
                                    <template #default="{ row }">
                                        <span>{{ row[item.field] }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    v-if="item.column_status == 1 && item.column_type == 'select'"
                                    :title="item.column_name"
                                    :field="item.field"
                                    :width="item.column_width"
                                    :key="item.field + index"
                                >
                                    <template #default="{ row }">
                                        <span>{{
                                                $selectLable.selectLable(
                                                    row[item.field],
                                                    allArr[item.field.replace('_no', '')],
                                                    item.field,
                                                    item.field.replace('_no', '_name')
                                                )
                                            }}</span>
                                    </template>
                                </vxe-table-column>
                            </template>

                            <template #empty>
                                <span style="color: red">
                                    <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                                </span>
                            </template>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane label="物料明细" name="bomDtl">
                        <vxe-table
                            border
                            stripe
                            resizable
                            align="center"
                            ref="bomDtlTable"
                            :height="detailTableHeight"
                            show-overflow
                            show-header-overflow
                            highlight-hover-row
                            :data="form.bomDtl"
                            :row-class-name="rowChange"
                            :key="refushTable"
                            :scroll-y="{ enabled: true, gt: 50 }"
                        >
                            <vxe-table-column type="seq" field="seq" width="70" title="序号">
                                <template slot="header">
                                    <i class="el-icon-setting" @click.stop="isedit ? changeTable('142') : null"></i>
                                </template>
                                <template slot-scope="scoped">
                                    <span><i style="font-style: normal">{{ scoped.seq }}</i></span>
                                </template>
                            </vxe-table-column>

                            <template v-for="(item, index) in materialKeyList">
                                <vxe-table-column
                                    v-if="item.column_status == 1 && item.column_type != 'select'"
                                    :title="item.column_name"
                                    :field="item.field"
                                    :width="item.column_width"
                                    :key="item.field + index"
                                >
                                    <template #default="{ row }">
                                        <span>{{ row[item.field] }}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    v-if="item.column_status == 1 && item.column_type == 'select'"
                                    :title="item.column_name"
                                    :field="item.field"
                                    :width="item.column_width"
                                    :key="item.field + index"
                                >
                                    <template #default="{ row }">
                                        <span>{{
                                                $selectLable.selectLable(
                                                    row[item.field],
                                                    allArr[item.field.replace('_no', '')],
                                                    item.field,
                                                    item.field.replace('_no', '_name')
                                                )
                                            }}</span>
                                    </template>
                                </vxe-table-column>
                            </template>

                            <template #empty>
                                <span style="color: red">
                                    <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                                </span>
                            </template>
                        </vxe-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <!-- 页脚表单 -->
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item label="成品数量：">
                        <p>{{ productQtyTotal }}</p>
                    </el-form-item>
                    <el-form-item label="成品重量：">
                        <p>{{ productWgtTotal }}</p>
                    </el-form-item>
                    <el-form-item label="物料数量：">
                        <p>{{ bomQtyTotal }}</p>
                    </el-form-item>
                    <el-form-item label="物料重量：">
                        <p>{{ bomWgtTotal }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.id)" style="width: 73px">
                    {{ $t('common.cancel') }}
                </el-button>
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItSub">{{ $t('common.save') }}
                </el-button>
            </div>
        </div>
        <!-- 导入明细弹窗 -->
        <el-dialog title="导入明细" :visible.sync="showImpotDialog" width="45%" :before-close="handleClose">
            <div class="importDialogCenter">
                <div class="centerItem leftItem" @click="outTem">
                    <i class="el-icon-download avatar-uploader-icon"></i>
                    <p class="itemText">点击下载模板</p>
                </div>
                <div class="centerItem">
                    <el-upload
                        class="upload-demo"
                        :on-error="uploadError"
                        :on-success="uploadSuccess"
                        :show-file-list="false"
                        style="width: 100%"
                        :headers="headers"
                        drag
                        :action="this.$baseURL + 'importdtl_BarcodesAssembly'"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：.xlsx</div>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialog = false">取 消</el-button>
                <el-button type="primary" @click="showImpotDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false"
                   destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index"
                                       @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost"
                                       :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2"
                                           v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm')
                            }}
                        </el-button>
                    </div>
                </div>
            </div>
        </el-drawer>

    </div>
</template>

<script>
import { multiplication, multiplication2, getExportExcel } from '@/utils/multAdexportExcel.js';
import {
    apiBarcodesAssemblyGetData,
    apiBarcodesAssemblyGetPull,
    apiBarcodesAssemblyUpdateData,
    apiBarcodesAssemblyAddData,
    apiBarcodesAssemblyDelData,
    apiBarcodesAssemblycheck,
    apiBarcodesAssemblyIsAllowUp,
    apiBarcodesAssemblyPrintLab,
    apiCurrentPermisson,
    apiSystem,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    insjQuitSum,
    apiCustStyleWage
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';

export default {
    name: 'BarcodesAssembly',
    data() {
        return {
            wgtTotal: 0,
            allArr: '',
            form: { remark: '' },
            isedit: true,
            isCheck: false,
            first: null,
            last: null,
            dialogImageUrl: '',
            dialogVisible: false,
            isAdd: false,
            loading: false,
            nullBtn: false,
            systemSet: '',
            dtlIndex: '-1', // 明细表当前悬停行索引
            isSave: true,
            type: '4',
            maxHeight: 480,
            showImpotDialog: false,
            headers: {},
            topIptInsjOrder: '',
            topLeftForm: {},

            // 列配置操作相关字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            // 成品数据列配置（id=141）：成品数据Form与成品明细表格共用
            productKeyList: [],
            originalProductKeyList: [], // 保存原始的成品列配置（包含所有语言）
            // 物料数据列配置（id=142）：物料数据表格与物料明细表格共用
            materialKeyList: [],
            originalMaterialKeyList: [], // 保存原始的物料列配置（包含所有语言）
            // 成品数据From表单对象（组装编辑区）
            productForm: {},
            // 成品数据From表单是否处于编辑状态（点击新增后才可编辑）
            productFormEditable: false,
            // 物料数据表格数据（组装编辑区）
            materialList: [],
            // 当前正在编辑的成品明细行（非空表示修改组装模式）
            editingDtlRow: null,
            // 明细tabs当前激活页
            activeTab: 'productDtl',
            // 物料数据表格高度
            materialHeight: 500,
            // 明细表格高度（固定值，与容器匹配）
            detailTableHeight: 620,

            keyStatus: '1',
            perData: {} //权限
        };
    },
    computed: {
        /** 成品数据Form展示的列（仅显示已启用字段） */
        productShowKeyList() {
            return this.productKeyList.filter((item) => item.column_status == 1);
        },
        /** 成品数量（成品明细行数） */
        productQtyTotal() {
            let list = this.form.productDtl || [];
            return list.length;
        },
        /** 成品重量（成品明细wgt合计） */
        productWgtTotal() {
            let list = this.form.productDtl || [];
            let total = list.reduce((sum, item) => sum + (Number(item.wgt) || 0), 0);
            return total.toFixed(this.systemSet ? this.systemSet.wgt : 2);
        },
        /** 物料数量（物料明细qty合计） */
        bomQtyTotal() {
            let list = this.form.bomDtl || [];
            let total = list.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
            return total.toFixed(this.systemSet ? this.systemSet.qty : 2);
        },
        /** 物料重量（物料明细wgt合计） */
        bomWgtTotal() {
            let list = this.form.bomDtl || [];
            let total = list.reduce((sum, item) => sum + (Number(item.wgt) || 0), 0);
            return total.toFixed(this.systemSet ? this.systemSet.wgt : 2);
        }
    },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getStoneData();
        this.getTable();
        this.getPermission();
        this.$nextTick(() => {
            this.calcTableHeights();
        });
        document.addEventListener('keydown', (event) => {
            this.mykeyup(event);
        });
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            this.geData();
        }
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalProductKeyList && this.originalProductKeyList.length > 0) {
                    this.productKeyList = translateColumns(this.originalProductKeyList, newLang || 'zh-CN');
                }
                if (this.originalMaterialKeyList && this.originalMaterialKeyList.length > 0) {
                    this.materialKeyList = translateColumns(this.originalMaterialKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    activated() {
        // 从其他页面跳转带bill_no时重新加载数据
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.geData();
        }
    },
    methods: {
        /** tab切换时触发vxe-table重新布局 */
        onDetailTabClick(tab) {
            this.$nextTick(() => {
                // vxe-table 重新计算布局（doLayout 为 el-table 方法，vxe-table 使用 recalculate）
                if (tab.name === 'productDtl' && this.$refs.productDtlTable) {
                    this.$refs.productDtlTable.recalculate();
                } else if (tab.name === 'bomDtl' && this.$refs.bomDtlTable) {
                    this.$refs.bomDtlTable.recalculate();
                }
            });
        },
        /** 根据容器实际高度计算表格高度 */
        calcTableHeights() {
            setTimeout(() => {
                // 物料数据表格高度 = 物料面板高度 - 标题栏 - padding
                let materialPanel = this.$el.querySelector('.material_panel');
                if (materialPanel && materialPanel.offsetHeight > 0) {
                    let titleEl = materialPanel.querySelector('.title');
                    let titleH = titleEl ? titleEl.offsetHeight : 44;
                    this.materialHeight = materialPanel.offsetHeight - titleH - 30;
                }
            }, 200);
        },
        /** 自定义标签打印 */
        labelClick() {
            // 收集勾选的成品明细行id，未勾选时传空数组，接口默认打印全部
            let data = this.$refs.productDtlTable ? this.$refs.productDtlTable.getCheckboxRecords() : [];
            let strId = [];
            for (let i = 0; i < data.length; i++) {
                strId.push(data[i].id);
            }
            let params = {
                id: this.form.id,
                dtlid: strId
            };
            apiBarcodesAssemblyPrintLab(params).then((res) => {
                if (res.code == 2000) {
                    this.$router.push({
                        path: '/printingfusion',
                        query: {
                            url: res.data.Url
                        }
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        /** Ctrl+S快捷键保存 */
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                if (!this.isedit) {
                    if (this.$route.path == '/BarcodesAssembly') {
                        this.saveItSub();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {
                });
        },
        /** 文件上传成功回调 */
        uploadSuccess(res) {
            if (res.code == 2000) {
                this.$message.success(res.msg);
                this.form.productDtl = res.data;
                this.showImpotDialog = false;
            } else {
                if (res.data.info instanceof Array) {
                    let str = [];
                    var s = '';
                    str = res.data.info;
                    for (let i = 0; i < str.length; i++) {
                        s += str[i] + '<br/>';
                    }
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: s
                    });
                } else {
                    this.$message.success(res.data.info);
                }
            }
        },
        uploadError(r) {
            this.$message.error('上传失败');
        },
        /** 下载导入模板 */
        outTem() {
            this.$axios
                .get(`${this.$baseURL}template_export_BarcodesAssembly`, {
                    params: {
                        token: this.token,
                        type: '明细'
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '明细导入模板.xls';
                    link.click();
                });
        },
        /** 加载单据数据 */
        geData(no) {
            this.$load.show();
            this.isedit = true;
            let bill_nos = this.$route.query.bill_no;
            let ids = this.$route.query.id;
            let bill_no = '';
            let id = '';
            if (bill_nos || ids) {
                this.type = null;
                bill_no = bill_nos;
                id = ids;
            }
            if (no) {
                id = no;
            }
            this.isAdd = false;
            apiBarcodesAssemblyGetData({
                type: this.type,
                id,
                bill_no
            }).then((res) => {
                if (res.code == 2000) {
                    let info = res.data;
                    this.form = info.data;
                    // 初始化成品明细与物料明细数组
                    if (!this.form.productDtl) {
                        this.$set(this.form, 'productDtl', []);
                    }
                    if (!this.form.bomDtl) {
                        this.$set(this.form, 'bomDtl', []);
                    }
                    // 重置组装编辑区
                    this.resetAssembly();
                    this.calcTableHeights();
                    this.last = info.last;
                    this.first = info.first;
                    this.topLeftForm = info.data.inmain;
                    this.maxHeight = 480;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    if (res.data.info == '暂无数据' || res.data.info == '没有这条数据') {
                        this.form = { productDtl: [], bomDtl: [] };
                        this.$forceUpdate();
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            });
            this.$load.close();
        },

        /** 获取成品数据（id=141）与物料数据（id=142）列配置 */
        getTable() {
            apiGetListCorrespondingData({
                id: '141'
            }).then((res) => {
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalProductKeyList = res.data;
                    // 根据当前语言转换列名
                    this.productKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
            apiGetListCorrespondingData({
                id: '142'
            }).then((res) => {
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalMaterialKeyList = res.data;
                    // 根据当前语言转换列名
                    this.materialKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        /** 打开列配置抽屉，type为表格列配置id（141成品/142物料） */
        changeTable(type) {
            if (type == '141') {
                this.keyList = this.productKeyList.map((item) => item);
                this.keyStatus = '141';
            } else if (type == '142') {
                this.keyList = this.materialKeyList.map((item) => item);
                this.keyStatus = '142';
            }
            this.drawers = true;
        },

        checkMove() {
        },
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        /** 获取下拉框数据源 */
        getStoneData() {
            apiBarcodesAssemblyGetPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        /** 下拉框选择变化时同步关联数据 */
        changeData(row, type) {
            const selectedNo = row[`${type}_no`];
            const arrayToSearch = this.allArr[type];

            if (!Array.isArray(arrayToSearch)) {
                console.error(`allArr[${type}] 不是数组或未定义`);
                return;
            }
            if (type + '_no' == 'style_no') {
                apiCustStyleWage({ cust_no: this.form.cust_no, style_no: selectedNo }).then((res) => {
                    if (res.code == 2000) {
                        for (var item in res.data) {
                            row[item] = res.data[item];
                        }
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }
            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo);

            if (idx !== -1) {
                const info = arrayToSearch[idx];
                row[`${type}_no`] = info[`${type}_no`];
                row[`${type}_name`] = info[`${type}_name`];
            } else {
                console.warn(`未找到编号为 ${selectedNo} 的数据`);
            }
        },
        /** 撤销编辑，重新加载数据 */
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            this.form = { productDtl: [], bomDtl: [] };
            this.geData(no);
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/BarcodesAssembly');
            }
        },
        /** 生成成品号 product_seq（当前最大序号+1） */
        genProductSeq() {
            let maxSeq = 0;
            (this.form.productDtl || []).forEach((item) => {
                let n = Number(item.product_seq);
                if (!isNaN(n) && n > maxSeq) {
                    maxSeq = n;
                }
            });
            return String(maxSeq + 1);
        },
        /** 判断组装编辑区是否有数据（自动生成的product_seq不参与判断） */
        hasAssemblyData() {
            let hasProduct = false;
            let productForm = this.productForm || {};
            Object.keys(productForm).forEach((key) => {
                if (key == 'product_seq') {
                    return;
                }
                if (productForm[key] !== '' && productForm[key] !== null && productForm[key] !== undefined) {
                    hasProduct = true;
                }
            });
            let hasMaterial = false;
            let fullData = this.$refs.xTable1 ? this.$refs.xTable1.getTableData().fullData || [] : this.materialList || [];
            fullData.forEach((item) => {
                Object.keys(item).forEach((key) => {
                    if (key == 'product_seq') {
                        return;
                    }
                    if (item[key] !== '' && item[key] !== null && item[key] !== undefined) {
                        hasMaterial = true;
                    }
                });
            });
            return hasProduct || hasMaterial;
        },
        /** 获取物料数据表格最新全量数据 */
        getMaterialFullData() {
            let fullData = [];
            if (this.$refs.xTable1) {
                fullData = this.$refs.xTable1.getTableData().fullData || [];
            } else {
                fullData = this.materialList || [];
            }
            return fullData;
        },
        /** 新增组装/修改组装：把成品数据与物料数据添加到成品明细和物料明细 */
        addAssembly() {
            if (this.isedit) {
                this.$message.error('该状态下不可编辑');
                return;
            }
            if (!this.productFormEditable) {
                this.$message.warning('请先点击成品数据的新增或修改按钮');
                return;
            }
            if (!this.hasAssemblyData()) {
                this.$message.warning('请先填写成品数据或物料数据');
                return;
            }
            if (!this.form.productDtl) {
                this.$set(this.form, 'productDtl', []);
            }
            if (!this.form.bomDtl) {
                this.$set(this.form, 'bomDtl', []);
            }
            // 获取物料数据表格最新全量数据
            let latestMaterial = this.getMaterialFullData();
            if (this.editingDtlRow) {
                // 修改已添加的成品组装信息
                let idx = this.form.productDtl.indexOf(this.editingDtlRow);
                if (idx > -1) {
                    let seq = this.editingDtlRow.product_seq;
                    let newProduct = this.$deepClone(this.productForm);
                    newProduct.product_seq = seq;
                    this.form.productDtl.splice(idx, 1, newProduct);
                    // 移除该成品号下的旧物料数据
                    let filterBomDtl = this.form.bomDtl.filter((item) => item.product_seq != seq);
                    // 添加新的物料数据（只添加已选择style_no的行）
                    latestMaterial.forEach((item) => {
                        if (item.style_no) {
                            let newItem = this.$deepClone(item);
                            newItem.product_seq = seq;
                            filterBomDtl.push(newItem);
                        }
                    });
                    // 重新赋值数组（vxe-table仅监听data引用变化，数组内部splice不触发刷新）
                    this.$set(this.form, 'productDtl', this.form.productDtl.slice());
                    this.$set(this.form, 'bomDtl', filterBomDtl);
                    this.$message.success('组装修改成功');
                }
                this.resetAssembly();
            } else {
                // 新增组装
                let seq = this.productForm.product_seq || this.genProductSeq();
                let newProduct = this.$deepClone(this.productForm);
                newProduct.product_seq = seq;
                this.form.productDtl.push(newProduct);
                // 只添加已选择style_no的物料行
                latestMaterial.forEach((item) => {
                    if (item.style_no) {
                        let newItem = this.$deepClone(item);
                        newItem.product_seq = seq;
                        this.form.bomDtl.push(newItem);
                    }
                });
                // 重新赋值数组（vxe-table仅监听data引用变化，数组内部push不触发刷新）
                this.$set(this.form, 'productDtl', this.form.productDtl.slice());
                this.$set(this.form, 'bomDtl', this.form.bomDtl.slice());
                this.$message.success('组装添加成功');
                this.resetAssembly();
            }
        },
        /** 点击新增按钮：进入组装编辑状态并自动生成成品号 */
        newAssembly() {
            if (this.isedit) {
                return;
            }
            this.resetAssembly();
            this.productFormEditable = true;
            // 自动生成成品号 product_seq
            let seq = this.genProductSeq();
            this.$set(this.productForm, 'product_seq', seq);
            // 预置列配置字段，保证表单响应式更新
            this.ensureProductFormFields();
            // 物料数据表格预留一行空行，并带入成品号与物料柜台
            // this.materialList = [{ product_seq: seq, counter_no: this.form.bom_counter_no || '' }];

            setTimeout(() => {
                for (let i = 0; i < 3; i++) {
                    this.insertEvent(-1);
                }
            }, 100);
        },
        /** 预置成品列配置中的字段，保证计算赋值可响应式更新 */
        ensureProductFormFields() {
            this.productKeyList.forEach((item) => {
                if (item.field && this.productForm[item.field] === undefined) {
                    this.$set(this.productForm, item.field, '');
                }
            });
        },
        /** 保存前自动把编辑区未添加的组装加入明细 */
        autoAddAssembly() {
            if (this.productFormEditable && this.hasAssemblyData()) {
                // 编辑区有未添加的组装数据，先添加
                this.addAssembly();
            }
        },
        /** 点击修改按钮：确认进入成品修改模式 */
        editAssembly() {
            if (!this.editingDtlRow) {
                this.$message.warning('请先在成品明细中选择要修改的成品');
                return;
            }
            // editingDtlRow 已在 productDtlRowClick 中设置，此处确保表单可编辑
            this.productFormEditable = true;
        },
        /** 删除当前选中的成品明细行及其关联物料 */
        deleteProductDtl() {
            if (!this.editingDtlRow) {
                this.$message.warning('请先在成品明细中选择要删除的成品');
                return;
            }
            this.$confirm('确认删除该成品及其关联物料数据？', '提示', {
                type: 'warning'
            }).then(() => {
                let seq = this.editingDtlRow.product_seq;
                // 从成品明细中移除
                let idx = this.form.productDtl.indexOf(this.editingDtlRow);
                if (idx > -1) {
                    this.form.productDtl.splice(idx, 1);
                }
                // 从物料明细中移除关联数据
                if (this.form.bomDtl) {
                    let filterBom = this.form.bomDtl.filter((item) => item.product_seq != seq);
                    this.$set(this.form, 'bomDtl', filterBom);
                }
                this.$set(this.form, 'productDtl', this.form.productDtl.slice());
                this.$message.success('删除成功');
                this.resetAssembly();
            }).catch(() => {
            });
        },
        /** 取消新增/修改组装，清空编辑区 */
        cancelEditAssembly() {
            this.resetAssembly();
        },
        /** 重置组装编辑区 */
        resetAssembly() {
            this.productForm = {};
            this.materialList = [];
            this.editingDtlRow = null;
            this.productFormEditable = false;
        },
        /** 点击成品明细行：回填成品数据Form，并按product_seq带出物料数据（默认只读，需点击修改按钮才可编辑） */
        productDtlRowClick({ row }) {
            if (!row) {
                return;
            }
            // 新增成品数据时不允许点击右侧成品明细，避免编辑一半被覆盖
            if (this.productFormEditable) {
                this.$message.warning('请先保存或取消当前编辑的成品数据');
                return;
            }
            this.editingDtlRow = row;
            // 点击行时默认不可编辑，需点击修改按钮才可编辑
            this.productFormEditable = false;
            // 该行成品数据带到成品数据Form赋值
            this.productForm = this.$deepClone(row);
            // 预置列配置字段，保证计算赋值可响应式更新
            this.ensureProductFormFields();
            // 通过成品号product_seq获取物料明细中相同成品号的数据
            this.materialList = this.$deepClone(
                (this.form.bomDtl || []).filter((item) => item.product_seq == row.product_seq)
            );
            if (!this.materialList || this.materialList.length == 0) {
                // 空行默认带出主表物料柜台所选择的柜台
                this.materialList = [{ product_seq: row.product_seq, counter_no: this.form.bom_counter_no || '' }];
            }
        },
        /** 成品数据Form输入处理（数字校验+触发计算） */
        handleProductInput(field, type) {
            // 将原明细表格的计算改为成品数据Form的计算
            this.calculationProduct(this.productForm);
            if (type === 'number') {
                let inputValue = this.productForm[field];
                if (inputValue) {
                    // 只允许数字、一个小数点和一个负号
                    inputValue = inputValue
                        .replace(/[^0-9.-]/g, '')
                        .replace(/(\..*)\./g, '$1');
                    if (inputValue === '.') {
                        inputValue = '0.';
                    }
                    if (inputValue && inputValue[0] === '-') {
                        inputValue = '-' + inputValue.slice(1).replace(/[^0-9.]/g, '');
                    } else {
                        inputValue = inputValue.replace(/-/g, '');
                    }
                    this.productForm[field] = inputValue;
                }
            }
        },
        /** 成品数据Form下拉变化时同步关联数据 */
        changeProductData(type) {
            const selectedNo = this.productForm[`${type}_no`];
            const arrayToSearch = this.allArr[type];
            if (!Array.isArray(arrayToSearch)) {
                return;
            }
            if (type + '_no' == 'style_no') {
                apiCustStyleWage({ cust_no: this.form.cust_no, style_no: selectedNo }).then((res) => {
                    if (res.code == 2000) {
                        for (var item in res.data) {
                            this.$set(this.productForm, item, res.data[item]);
                        }
                        // 同步后重新计算
                        this.calculationProduct(this.productForm);
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }
            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo);
            if (idx !== -1) {
                const info = arrayToSearch[idx];
                this.$set(this.productForm, `${type}_no`, info[`${type}_no`]);
                this.$set(this.productForm, `${type}_name`, info[`${type}_name`]);
                // 选择成品后带出该产品的bom数据到物料数据表格，并自动填充成品号与物料柜台
                if (type == 'style' && info.bom && Array.isArray(info.bom)) {
                    let bomData = this.$deepClone(info.bom);
                    let currentSeq = this.productForm.product_seq;
                    bomData.forEach(item => {
                        item.product_seq = currentSeq;
                        // 新增物料数据默认带出主表物料柜台所选择的柜台
                        item.counter_no = this.form.bom_counter_no || '';

                        item.inqty_prc = 0;
                        item.inqty_prc1 = 0;
                        item.inqty_prc2 = 0;
                        item.inwgt_prc = 0;
                        item.inwgt_prc1 = 0;
                        item.inwgt_prc2 = 0;
                        item.inadd_amt = 0;
                        item.inamt = 0;

                        item.saleqty_prc = 0;
                        item.saleqty_prc1 = 0;
                        item.saleqty_prc2 = 0;
                        item.salewgt_prc = 0;
                        item.salewgt_prc1 = 0;
                        item.salewgt_prc2 = 0;
                        item.saleadd_amt = 0;
                        item.saleamt = 0;
                    });
                    this.materialList = bomData;
                }
            }
            // 下拉变化后重新计算
            this.calculationProduct(this.productForm);
        },
        /** 物料柜台变化：提示是否同步修改物料数据与物料明细的柜台 */
        onBomCounterChange() {
            // 无物料数据时无需提示
            let hasData =
                (this.form.bomDtl || []).length > 0 ||
                this.getMaterialFullData().some((item) => item.style_no);
            if (!hasData) {
                return;
            }
            this.$confirm('是否同步修改物料数据与物料明细的柜台？', '提示', {
                type: 'warning'
            }).then(() => {
                let counterNo = this.form.bom_counter_no || '';
                let counterItem = (this.allArr.counter || []).find((item) => item.counter_no === counterNo);
                let counterName = counterItem ? counterItem.counter_name || '' : '';
                // 更新物料数据（编辑区表格）的柜台
                let fullData = this.getMaterialFullData();
                fullData.forEach((item) => {
                    this.$set(item, 'counter_no', counterNo);
                    this.$set(item, 'counter_name', counterName);
                });
                this.materialList = fullData.slice();
                // 更新物料明细的柜台，重新赋值数组触发刷新
                (this.form.bomDtl || []).forEach((item) => {
                    this.$set(item, 'counter_no', counterNo);
                    this.$set(item, 'counter_name', counterName);
                });
                this.$set(this.form, 'bomDtl', (this.form.bomDtl || []).slice());
            }).catch(() => {
            });
        },
        /** 点击编辑按钮，检查是否允许编辑 */
        handelEdit() {
            apiBarcodesAssemblyIsAllowUp({ id: this.form.id }).then((res) => {
                if (res.code == 2000) {
                    // 接口返回允许操作，进入编辑状态
                    this.isSave = true;
                    this.isedit = false;
                    // 清空左侧编辑区
                    this.resetAssembly();
                } else {
                    this.$message.error(res.data.info || '不允许操作');
                }
            });
        },
        /** 保存前校验数据合法性 */
        saveItSub() {
            this.saveIt();
        },
        /** 执行保存（新增/修改） */
        saveIt() {
            if (this.isSave) {
                this.isSave = false;
                // 保存前把编辑区未添加的组装先加入明细
                this.autoAddAssembly();
                let data = this.$deepClone(this.form);
                data.productDtl = this.$deepClone(this.form.productDtl || []);
                data.bomDtl = this.$deepClone(this.form.bomDtl || []);
                delete data.dtl;
                data['inmain'] = this.topLeftForm;
                data['check'] = this.form.check == true ? '1' : '0';

                this.$load.show();
                if (this.isAdd == true) {
                    apiBarcodesAssemblyAddData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功');
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isAdd = false;
                            this.isedit = true;
                            // 初始化明细数组并重置组装编辑区
                            if (!this.form.productDtl) {
                                this.$set(this.form, 'productDtl', []);
                            }
                            if (!this.form.bomDtl) {
                                this.$set(this.form, 'bomDtl', []);
                            }
                            this.resetAssembly();
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/BarcodesAssembly');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info || '保存失败');
                            this.isSave = true;
                        }
                        this.$load.close();
                    }).catch(() => {
                        this.isSave = true;
                        this.$load.close();
                    });
                } else {
                    apiBarcodesAssemblyUpdateData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功');
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isedit = true;
                            // 初始化明细数组并重置组装编辑区
                            if (!this.form.productDtl) {
                                this.$set(this.form, 'productDtl', []);
                            }
                            if (!this.form.bomDtl) {
                                this.$set(this.form, 'bomDtl', []);
                            }
                            this.resetAssembly();
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info || '保存失败');
                            this.isSave = true;
                        }
                        this.$load.close();
                    }).catch(() => {
                        this.isSave = true;
                        this.$load.close();
                    });
                }
            }
        },
        /** 新增单据，初始化表单数据 */
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isedit = false;
                this.form = { bill_date: '' };
                this.form.productDtl = [];
                this.form.bomDtl = [];
                this.topLeftForm = {};
                this.form.check = false;
                this.isAdd = true;
                this.isCheck = false;
                this.nullBtn = false;
                this.form.bill_date = this.$getTime();
                this.maxHeight = 480;
                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                this.form[formKeys[index]] = '';
                            }
                        } else {
                            this.form[formKeys[index]] = '';
                        }
                    }
                });
                // 主表柜台拆分为成品柜台与物料柜台，均默认带出默认柜台
                const defaultCounter = (this.allArr.counter || []).find((item) => item.isdefault == 1);
                this.form.product_counter_no = defaultCounter ? defaultCounter.counter_no : '';
                this.form.bom_counter_no = defaultCounter ? defaultCounter.counter_no : '';
                setTimeout(() => {
                    // 初始化组装编辑区：成品Form置空，清空编辑区
                    this.resetAssembly();
                }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
            this.type = '4';
        },
        /** 删除当前单据 */
        delOrder() {
            apiBarcodesAssemblyIsAllowUp({ id: this.form.id }).then((res) => {
                if (res.code === 2000) {
                    this.$confirm('确定要删除吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        apiBarcodesAssemblyDelData({
                            id: this.form.id
                        }).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '删除成功', type: 'success' });
                                if (res.data.data == null) {
                                    this.form = { productDtl: [], bomDtl: [] };
                                    this.nullBtn = true;
                                } else {
                                    this.form = res.data.data;
                                    if (!this.form.productDtl) {
                                        this.form.productDtl = [];
                                    }
                                    if (!this.form.bomDtl) {
                                        this.form.bomDtl = [];
                                    }
                                    if (this.form.check == 1) {
                                        this.isCheck = true;
                                    } else {
                                        this.isCheck = false;
                                    }
                                }
                                this.last = res.data.last;
                                this.first = res.data.first;
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        /** 同步行序号 */
        rowChange(row) {
            row.row.seq = row.seq;
        },
        /** 审核/撤销审核 */
        Check(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apiBarcodesAssemblycheck({
                id: this.form.id,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.type = '';
                this.geData(this.form.id);
            });
        },
        /** 翻页（上/下/首/末） */
        changePage(v) {
            this.type = v;
            let bill_nos = this.$route.query.bill_no;
            if (bill_nos) {
                this.$router.replace({ path: '/BarcodesAssembly' });
                this.geData(this.form.id);
                return;
            }
            this.geData(this.form.id);
        },
        /** 明细表插入新行（物料数据表格） */
        async insertEvent(row) {
            // 默认带出主表物料柜台所选择的柜台
            let record = {
                style_no: '',
                alloy: 1,
                qty: 1,
                containloss_rate: 1,
                counter_no: this.form.bom_counter_no || '',
                product_seq: this.productForm.product_seq || ''
            };
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            await this.$refs.xTable1.setActiveCell(newRow, 'seq');
        },
        /** 判断当前行是否可编辑（物料数据表格：需在组装编辑状态下） */
        activeRowMethod(row) {
            if (this.isedit == false && this.productFormEditable) {
                return true;
            } else if (this.isedit == true) {
                this.$message.error('该状态下不可编辑');
                return false;
            } else {
                this.$message.warning('请先点击新增按钮');
                return false;
            }
        },

        /** 计算物料数据 */
        calculationBomDtl(row) {
            let inamt = multiplication(Number(row.qty || 0), Number(row.inqty_prc || 0))
                + multiplication(Number(row.qty || 0), Number(row.inqty_prc1 || 0))
                + multiplication(Number(row.qty || 0), Number(row.inqty_prc2 || 0))
                + multiplication(Number(row.wgt || 0), Number(row.inwgt_prc || 0))
                + multiplication(Number(row.wgt || 0), Number(row.inwgt_prc1 || 0))
                + multiplication(Number(row.wgt || 0), Number(row.inwgt_prc2 || 0))
                + Number(row.inadd_amt || 0);
            row.inamt = inamt.toFixed(this.systemSet.amt);


            let saleamt = multiplication(Number(row.qty || 0), Number(row.saleqty_prc || 0))
                + multiplication(Number(row.qty || 0), Number(row.saleqty_prc1 || 0))
                + multiplication(Number(row.qty || 0), Number(row.saleqty_prc2 || 0))
                + multiplication(Number(row.wgt || 0), Number(row.salewgt_prc || 0))
                + multiplication(Number(row.wgt || 0), Number(row.salewgt_prc1 || 0))
                + multiplication(Number(row.wgt || 0), Number(row.salewgt_prc2 || 0))
                + Number(row.inadd_amt || 0);
            row.saleamt = saleamt.toFixed(this.systemSet.amt);
        },
        /** 计算成品数据 */
        calculationProduct(row) {
            // 含耗重
            let containloss_wgt = multiplication(row.wgt, row.containloss_rate);
            row.containloss_wgt = containloss_wgt.toFixed(this.systemSet.wgt);
            // 折足重
            let trans_wgt = multiplication(row.containloss_wgt, row.alloy);
            row.trans_wgt = trans_wgt.toFixed(this.systemSet.wgt);

            let stone1_sale_qty_amt =
                multiplication2(row.stone1_qty, row.stone1_sale_qty_prc, row.stone1_qty, row.stone1_sale_qty_wage);
            row.stone1_sale_qty_amt = stone1_sale_qty_amt.toFixed(this.systemSet.amt);

            let stone1_sale_wgt_amt =
                multiplication2(row.stone1_wgt, row.stone1_sale_wgt_prc, row.stone1_wgt, row.stone1_sale_wgt_wage);
            row.stone1_sale_wgt_amt = stone1_sale_wgt_amt.toFixed(this.systemSet.amt);

            let stone2_sale_qty_amt =
                multiplication2(row.stone2_qty, row.stone2_sale_qty_prc, row.stone2_qty, row.stone2_sale_qty_wage);
            row.stone2_sale_qty_amt = stone2_sale_qty_amt.toFixed(this.systemSet.amt);

            let stone2_sale_wgt_amt =
                multiplication2(row.stone2_wgt, row.stone2_sale_wgt_prc, row.stone2_wgt, row.stone2_sale_wgt_wage);
            row.stone2_sale_wgt_amt = stone2_sale_wgt_amt.toFixed(this.systemSet.amt);

            let stone3_sale_qty_amt =
                multiplication2(row.stone3_qty, row.stone3_sale_qty_prc, row.stone3_qty, row.stone3_sale_qty_wage);
            row.stone3_sale_qty_amt = stone3_sale_qty_amt.toFixed(this.systemSet.amt);

            let stone3_sale_wgt_amt =
                multiplication2(row.stone3_wgt, row.stone3_sale_wgt_prc, row.stone3_wgt, row.stone3_sale_wgt_wage);
            row.stone3_sale_wgt_amt = stone3_sale_wgt_amt.toFixed(this.systemSet.amt);

            let stone4_sale_qty_amt =
                multiplication2(row.stone4_qty, row.stone4_sale_qty_prc, row.stone4_qty, row.stone4_sale_qty_wage);
            row.stone4_sale_qty_amt = stone4_sale_qty_amt.toFixed(this.systemSet.amt);

            let stone4_sale_wgt_amt =
                multiplication2(row.stone4_wgt, row.stone4_sale_wgt_prc, row.stone4_wgt, row.stone4_sale_wgt_wage);
            row.stone4_sale_wgt_amt = stone4_sale_wgt_amt.toFixed(this.systemSet.amt);

            let stone5_sale_qty_amt =
                multiplication2(row.stone5_qty, row.stone5_sale_qty_prc, row.stone5_qty, row.stone5_sale_qty_wage);
            row.stone5_sale_qty_amt = stone5_sale_qty_amt.toFixed(this.systemSet.amt);

            let stone5_sale_wgt_amt =
                multiplication2(row.stone5_wgt, row.stone5_sale_wgt_prc, row.stone5_wgt, row.stone5_sale_wgt_wage);
            row.stone5_sale_wgt_amt = stone5_sale_wgt_amt.toFixed(this.systemSet.amt);

            let mainstone_sale_qty_amt =
                multiplication2(row.mainstone_qty, row.mainstone_sale_qty_prc, row.mainstone_qty, row.mainstone_sale_qty_wage);
            row.mainstone_sale_qty_amt = mainstone_sale_qty_amt.toFixed(this.systemSet.amt);

            let mainstone_sale_wgt_amt =
                multiplication2(row.mainstone_wgt, row.mainstone_sale_wgt_prc, row.mainstone_wgt, row.mainstone_sale_wgt_wage);
            row.mainstone_sale_wgt_amt = mainstone_sale_wgt_amt.toFixed(this.systemSet.amt);

            let stone_sale_qty_amt =
                mainstone_sale_qty_amt + stone1_sale_qty_amt + stone2_sale_qty_amt + stone3_sale_qty_amt + stone4_sale_qty_amt + stone5_sale_qty_amt;
            row.stone_sale_qty_amt = stone_sale_qty_amt.toFixed(this.systemSet.amt);

            let stone_sale_wgt_amt =
                mainstone_sale_wgt_amt + stone1_sale_wgt_amt + stone2_sale_wgt_amt + stone3_sale_wgt_amt + stone4_sale_wgt_amt + stone5_sale_wgt_amt;
            row.stone_sale_wgt_amt = stone_sale_wgt_amt.toFixed(this.systemSet.amt);


            let mainstone_sale_amt =
                multiplication2(row.mainstone_qty, row.mainstone_sale_qty_prc, row.mainstone_qty, row.mainstone_sale_qty_wage) +
                multiplication2(row.mainstone_wgt, row.mainstone_sale_wgt_prc, row.mainstone_wgt, row.mainstone_sale_wgt_wage);
            row.mainstone_sale_amt = mainstone_sale_amt.toFixed(this.systemSet.amt);

            let stone1_sale_amt =
                multiplication2(row.stone1_qty, row.stone1_sale_qty_prc, row.stone1_qty, row.stone1_sale_qty_wage) +
                multiplication2(row.stone1_wgt, row.stone1_sale_wgt_prc, row.stone1_wgt, row.stone1_sale_wgt_wage);
            row.stone1_sale_amt = stone1_sale_amt.toFixed(this.systemSet.amt);

            let stone2_sale_amt =
                multiplication2(row.stone2_qty, row.stone2_sale_qty_prc, row.stone2_qty, row.stone2_sale_qty_wage) +
                multiplication2(row.stone2_wgt, row.stone2_sale_wgt_prc, row.stone2_wgt, row.stone2_sale_wgt_wage);
            row.stone2_sale_amt = stone2_sale_amt.toFixed(this.systemSet.amt);

            let stone3_sale_amt =
                multiplication2(row.stone3_qty, row.stone3_sale_qty_prc, row.stone3_qty, row.stone3_sale_qty_wage) +
                multiplication2(row.stone3_wgt, row.stone3_sale_wgt_prc, row.stone3_wgt, row.stone3_sale_wgt_wage);
            row.stone3_sale_amt = stone3_sale_amt.toFixed(this.systemSet.amt);

            let stone4_sale_amt =
                multiplication2(row.stone4_qty, row.stone4_sale_qty_prc, row.stone4_qty, row.stone4_sale_qty_wage) +
                multiplication2(row.stone4_wgt, row.stone4_sale_wgt_prc, row.stone4_wgt, row.stone4_sale_wgt_wage);
            row.stone4_sale_amt = stone4_sale_amt.toFixed(this.systemSet.amt);

            let stone5_sale_amt =
                multiplication2(row.stone5_qty, row.stone5_sale_qty_prc, row.stone5_qty, row.stone5_sale_qty_wage) +
                multiplication2(row.stone5_wgt, row.stone5_sale_wgt_prc, row.stone5_wgt, row.stone5_sale_wgt_wage);
            row.stone5_sale_amt = stone5_sale_amt.toFixed(this.systemSet.amt);

            let stone_sale_amt =
                Number(row.mainstone_sale_amt || 0) +
                Number(row.stone1_sale_amt || 0) +
                Number(row.stone2_sale_amt || 0) +
                Number(row.stone3_sale_amt || 0) +
                Number(row.stone4_sale_amt || 0) +
                Number(row.stone5_sale_amt || 0);
            row.stone_sale_amt = stone_sale_amt.toFixed(this.systemSet.amt);


            let stone1_qty_amt =
                multiplication2(row.stone1_qty, row.stone1_qty_prc, row.stone1_qty, row.stone1_qty_wage);
            row.stone1_qty_amt = stone1_qty_amt.toFixed(this.systemSet.amt);

            let stone1_wgt_amt =
                multiplication2(row.stone1_wgt, row.stone1_wgt_prc, row.stone1_wgt, row.stone1_wgt_wage);
            row.stone1_wgt_amt = stone1_wgt_amt.toFixed(this.systemSet.amt);

            let stone2_qty_amt =
                multiplication2(row.stone2_qty, row.stone2_qty_prc, row.stone2_qty, row.stone2_qty_wage);
            row.stone2_qty_amt = stone2_qty_amt.toFixed(this.systemSet.amt);

            let stone2_wgt_amt =
                multiplication2(row.stone2_wgt, row.stone2_wgt_prc, row.stone2_wgt, row.stone2_wgt_wage);
            row.stone2_wgt_amt = stone2_wgt_amt.toFixed(this.systemSet.amt);

            let stone3_qty_amt =
                multiplication2(row.stone3_qty, row.stone3_qty_prc, row.stone3_qty, row.stone3_qty_wage);
            row.stone3_qty_amt = stone3_qty_amt.toFixed(this.systemSet.amt);

            let stone3_wgt_amt =
                multiplication2(row.stone3_wgt, row.stone3_wgt_prc, row.stone3_wgt, row.stone3_wgt_wage);
            row.stone3_wgt_amt = stone3_wgt_amt.toFixed(this.systemSet.amt);

            let stone4_qty_amt =
                multiplication2(row.stone4_qty, row.stone4_qty_prc, row.stone4_qty, row.stone4_qty_wage);
            row.stone4_qty_amt = stone4_qty_amt.toFixed(this.systemSet.amt);

            let stone4_wgt_amt =
                multiplication2(row.stone4_wgt, row.stone4_wgt_prc, row.stone4_wgt, row.stone4_wgt_wage);
            row.stone4_wgt_amt = stone4_wgt_amt.toFixed(this.systemSet.amt);

            let stone5_qty_amt =
                multiplication2(row.stone5_qty, row.stone5_qty_prc, row.stone5_qty, row.stone5_qty_wage);
            row.stone5_qty_amt = stone5_qty_amt.toFixed(this.systemSet.amt);

            let stone5_wgt_amt =
                multiplication2(row.stone5_wgt, row.stone5_wgt_prc, row.stone5_wgt, row.stone5_wgt_wage);
            row.stone5_wgt_amt = stone5_wgt_amt.toFixed(this.systemSet.amt);

            let mainstone_qty_amt =
                multiplication2(row.mainstone_qty, row.mainstone_qty_prc, row.mainstone_qty, row.mainstone_qty_wage);
            row.mainstone_qty_amt = mainstone_qty_amt.toFixed(this.systemSet.amt);

            let mainstone_wgt_amt =
                multiplication2(row.mainstone_wgt, row.mainstone_wgt_prc, row.mainstone_wgt, row.mainstone_wgt_wage);
            row.mainstone_wgt_amt = mainstone_wgt_amt.toFixed(this.systemSet.amt);

            let stone_qty_amt =
                mainstone_qty_amt + stone1_qty_amt + stone2_qty_amt + stone3_qty_amt + stone4_qty_amt + stone5_qty_amt;
            row.stone_qty_amt = stone_qty_amt.toFixed(this.systemSet.amt);

            let stone_wgt_amt =
                mainstone_wgt_amt + stone1_wgt_amt + stone2_wgt_amt + stone3_wgt_amt + stone4_wgt_amt + stone5_wgt_amt;
            row.stone_wgt_amt = stone_wgt_amt.toFixed(this.systemSet.amt);

            let mainstone_amt =
                multiplication2(row.mainstone_qty, row.mainstone_qty_prc, row.mainstone_qty, row.mainstone_qty_wage) +
                multiplication2(row.mainstone_wgt, row.mainstone_wgt_prc, row.mainstone_wgt, row.mainstone_wgt_wage);
            row.mainstone_amt = mainstone_amt.toFixed(this.systemSet.amt);
            let stone1_amt =
                multiplication2(row.stone1_qty, row.stone1_qty_prc, row.stone1_qty, row.stone1_qty_wage) +
                multiplication2(row.stone1_wgt, row.stone1_wgt_prc, row.stone1_wgt, row.stone1_wgt_wage);
            row.stone1_amt = stone1_amt.toFixed(this.systemSet.amt);

            let stone2_amt =
                multiplication2(row.stone2_qty, row.stone2_qty_prc, row.stone2_qty, row.stone2_qty_wage) +
                multiplication2(row.stone2_wgt, row.stone2_wgt_prc, row.stone2_wgt, row.stone2_wgt_wage);
            row.stone2_amt = stone2_amt.toFixed(this.systemSet.amt);

            let stone3_amt =
                multiplication2(row.stone3_qty, row.stone3_qty_prc, row.stone3_qty, row.stone3_qty_wage) +
                multiplication2(row.stone3_wgt, row.stone3_wgt_prc, row.stone3_wgt, row.stone3_wgt_wage);
            row.stone3_amt = stone3_amt.toFixed(this.systemSet.amt);

            let stone4_amt =
                multiplication2(row.stone4_qty, row.stone4_qty_prc, row.stone4_qty, row.stone4_qty_wage) +
                multiplication2(row.stone4_wgt, row.stone4_wgt_prc, row.stone4_wgt, row.stone4_wgt_wage);
            row.stone4_amt = stone4_amt.toFixed(this.systemSet.amt);

            let stone5_amt =
                multiplication2(row.stone5_qty, row.stone5_qty_prc, row.stone5_qty, row.stone5_qty_wage) +
                multiplication2(row.stone5_wgt, row.stone5_wgt_prc, row.stone5_wgt, row.stone5_wgt_wage);
            row.stone5_amt = stone5_amt.toFixed(this.systemSet.amt);

            let stone_amt =
                Number(row.mainstone_amt || 0) +
                Number(row.stone1_amt || 0) +
                Number(row.stone2_amt || 0) +
                Number(row.stone3_amt || 0) +
                Number(row.stone4_amt || 0) +
                Number(row.stone5_amt || 0);
            row.stone_amt = stone_amt.toFixed(this.systemSet.amt);


            // 金料金额
            let metal_amt = multiplication(row.trans_wgt, row.metal_wgt_prc);
            row.metal_amt = metal_amt.toFixed(this.systemSet.amt);

            // 入库工费金额
            let inamt_wage =
                multiplication2(row.qty, row.inqty_prc, row.wgt, row.inwgt_prc) +
                multiplication2(row.qty, row.inadd_qtywage, row.wgt, row.inadd_wgtwage) +
                multiplication2(row.containloss_wgt, row.incontainloss_wgt_prc, row.wgt, row.inpre_wgt_prc) +
                Number(row.inadd_wage || 0);
            row.inamt_wage = inamt_wage.toFixed(this.systemSet.amt);

            // 出库工费金额
            let saleamt_wage =
                multiplication2(row.qty, row.saleqty_prc, row.wgt, row.salewgt_prc) +
                multiplication2(row.qty, row.saleadd_qtywage, row.wgt, row.saleadd_wgtwage) +
                multiplication2(row.containloss_wgt, row.salecontainloss_wgt_prc, row.wgt, row.salepre_wgt_prc) +
                Number(row.saleadd_wage || 0);
            row.saleamt_wage = saleamt_wage.toFixed(this.systemSet.amt);

            //入库金额
            let inamt =
                Number(row.metal_amt || 0) + Number(row.inamt_wage || 0) + Number(row.certificate_amt || 0) + Number(row.stone_amt || 0);
            row.inamt = inamt.toFixed(this.systemSet.amt);

            // 出库金额（工费 + 宝石售价金额）
            let saleamt =
                (Number(row.saleamt_wage) || 0) +
                (Number(row.stone_sale_amt) || 0);
            row.saleamt = saleamt.toFixed(this.systemSet.amt);
        },

        /** 调用接口重新计算合计数据（基于成品明细） */
        foottotal() {
            let dtl = this.form.productDtl || [];
            insjQuitSum({ dtl }).then((res) => {
                this.form.sumqty = res.data.sumqty;
                this.form.sumwgt = res.data.sumwgt;
                this.form.sumtrans_wgt = res.data.sumtrans_wgt;
                this.form.tran_qty = res.data.tran_qty;
                this.form.tran_wgt = res.data.tran_wgt;
                this.form.balprc_qty = res.data.balprc_qty;
                this.form.balqty_wgt = res.data.balprc_wgt;
                this.form.sumamt = res.data.sumamt;
                this.form.sumamt2 = res.data.sumamt2;
                this.$forceUpdate();
            });
        },
        /** 获取页面按钮权限 */
        getPermission() {
            apiCurrentPermisson({
                id: '154'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        /** 获取系统设置信息 */
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        /** 明细表悬停显示新增/删除按钮 */
        dtlenter(row) {
            if (!this.isedit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },
        /** 明细表新增行（物料数据表格）：需在成品数据新增/修改编辑状态下 */
        adddtl() {
            if (this.isedit || !this.productFormEditable) {
                return;
            }
            this.insertEvent(-1);
        },
        /** 明细表删除行（物料数据表格）：需在成品数据新增/修改编辑状态下 */
        deldtl(scoped) {
            if (this.isedit || !this.productFormEditable) {
                return;
            }
            this.$refs.xTable1.remove(scoped.row);
        },
        /** 跳转历史单据 */
        goHistory() {
            this.$router.push({ path: '/BarcodesAssemblyHistory', query: { page: 'BarcodesAssembly' } });
        },

        /** 输入框内容处理（物料表格数字校验） */
        handleInput(row, field, type, tableRef) {
            if (tableRef = 'materialTable') {
                this.calculationBomDtl(row);
            }
            if (type === 'number') {
                // 只允许数字、一个小数点和一个负号
                let inputValue = row[field]
                    .replace(/[^0-9.-]/g, '') // 删除非数字、非小数点和非负号的字符
                    .replace(/(\..*)\./g, '$1'); // 只保留第一个小数点

                // 如果输入值只有一个小数点，则替换为 '0.'
                if (inputValue === '.') {
                    inputValue = '0.';
                }
                if (inputValue === '') {
                    inputValue = '0';
                }
                // 处理负号，确保负号只能出现在字符串的开头
                if (inputValue && inputValue[0] === '-') {
                    // 负号在开头，允许它存在
                    inputValue = '-' + inputValue.slice(1).replace(/[^0-9.]/g, ''); // 清除负号后面的非法字符
                } else {
                    // 如果没有负号或者负号不是在开头，去掉所有负号
                    inputValue = inputValue.replace(/-/g, '');
                }

                // 更新 row[field] 的值
                row[field] = inputValue;
            }
        },
        /** 表格键盘导航（方向键/回车/Tab跳转） */
        jumptable(e, row, type) {
            // 所有列数据
            let column = this.$refs.xTable1.getTableColumn().fullColumn;
            // 所有行数据
            var rows = this.$refs.xTable1.getTableData().fullData;
            // 根据当前行获取行下标
            var rowIndex = this.$refs.xTable1.getVTRowIndex(row);

            // 当前列
            let nowcolumn = this.$refs.xTable1.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = this.$refs.xTable1.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;

            // 右移：查找下一个可编辑的列
            var jumpnum = columnIndex + 1;
            while (jumpnum < length) {
                if (!column[jumpnum]) break;
                // 从 materialKeyList 中查找对应列的 column_disabled 属性
                let targetField = column[jumpnum].property || column[jumpnum].field;
                let targetColumnConfig = this.materialKeyList.find(item => item.field === targetField);
                // 如果找不到配置或 column_disabled != 1，则是可编辑的
                if (targetColumnConfig && targetColumnConfig.column_disabled == 1) {
                    jumpnum++;
                } else {
                    break;
                }
            }

            // 左移：查找上一个可编辑的列
            var jumpnumleft = columnIndex - 1;
            while (jumpnumleft >= 0) {
                if (!column[jumpnumleft]) break;
                // 从 materialKeyList 中查找对应列的 column_disabled 属性
                let targetField = column[jumpnumleft].property || column[jumpnumleft].field;
                let targetColumnConfig = this.materialKeyList.find(item => item.field === targetField);
                // 如果找不到配置或 column_disabled != 1，则是可编辑的
                if (targetColumnConfig && targetColumnConfig.column_disabled == 1) {
                    jumpnumleft--;
                } else {
                    break;
                }
            }

            // 获取目标列的property
            var downtype = column[jumpnum] && jumpnum < length ? column[jumpnum].property : undefined;
            var uptype = column[jumpnumleft] && jumpnumleft >= 0 ? column[jumpnumleft].property : undefined;
            if (e.keyCode == '39' || e.keyCode == '13' || e.keyCode == '9') {
                if (jumpnum == length) {
                    // 最后一列，换行
                    if (rowIndex + 1 == rows.length) {
                        // 最后一行 先增加行在换行
                        this.adddtl();
                        rows = this.$refs.xTable1.getTableData().fullData;
                        setTimeout(() => {
                            this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                        }, 100);
                    } else {
                        this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                    }
                } else {
                    let allowBreak = true;
                    rows.forEach((item, index) => {
                        if (index === rowIndex) {
                            return;
                        }
                        if (item.barcode && item.barcode === row.barcode) {
                            this.$message.error('条码号不能重复');
                            row.barcode = '';
                            allowBreak = false;
                        }
                    });
                    if (allowBreak) {
                        // 跳转到下一列
                        this.$refs.xTable1.setActiveCell(row, downtype);
                    }
                }
            }
            if (e.keyCode == '37') {
                if (jumpnumleft == 0) {
                    // 第一列，向上换行
                    this.$refs.xTable1.setActiveRow(rows[rowIndex - 1]);
                } else {
                    // 跳转到上一列
                    this.$refs.xTable1.setActiveCell(row, uptype);
                }
            }

            // 向下移动 (keyCode == 40)
            if (e.keyCode == '40') {
                e.preventDefault(); // 阻止默认行为
                // 确保下移时在当前列，跳到下一行的相同列
                if (rowIndex + 1 < rows.length) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex + 1], nowcolumn.property);
                }
            }

            // 向上移动 (keyCode == 38)
            if (e.keyCode == '38') {
                e.preventDefault(); // 阻止默认行为
                // 确保上移时在当前列，跳到上一行的相同列
                if (rowIndex - 1 >= 0) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex - 1], nowcolumn.property);
                }
            }
        }
    }
};
</script>

<style scoped>
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}

/* 组装编辑区与明细标签页布局 */
.assembly_body {
    display: flex;
    height: 720px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-top: 10px;

    .assembly_left {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding-right: 10px;
        box-sizing: border-box;

        .product_panel {
            margin-top: 0;
            height: 55%;
            display: flex;
            flex-direction: column;
            overflow: hidden;

            .title {
                flex-shrink: 0;
            }

            .product_form {
                flex: 1;
                overflow-y: auto;
                padding-right: 10px;
                box-sizing: border-box;

                .el-form-item {
                    margin-bottom: 10px;
                }
            }
        }

        .material_panel {
            height: 45%;
        }
    }

    .assembly_right {
        width: 50%;
        height: 100%;

        .dtl_tabs {
            height: 100%;

            /deep/ .el-tabs__content {
                height: calc(100% - 39px);
                overflow: hidden;
            }

            /deep/ .el-tabs__item {
                font-weight: bold;
            }
        }
    }
}

.table1 {
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 10px;
    padding-top: 0;

    .title {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
            font-size: 16px;
            color: #000;
        }
    }
}
</style>
<style>
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}

.vxe-table thead {
    background-color: #ecf5ff;
}

.vxe-table {
    background: #fff;
}

/* 物料数据表中成品号列禁止编辑，隐藏编辑浮层 */
.orderorder .vxe-table .col--product_seq .vxe-cell--edit {
    display: none !important;
}

.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}

.box1 .el-select {
    width: 20%;
}

.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}

.el-select {
    width: 100%;
}

.list-item1:hover {
    background-color: #f5f7fa;
}

.orderorder {
    padding-bottom: 65px;
    box-sizing: border-box;
}

.orderorder .vxe-table .vxe-body--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-footer--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 12px 0;
}

.orderorder .vxe-table--footer-wrapper.body--wrapper {
    color: red;
}
</style>
<style scoped lang="scss">
.footer {
    height: 88px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;

        p {
            width: 20%; /* 调整为百分比 */
            min-width: 80px; /* 保证在极小的屏幕上也不会过小 */
        }

        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}

.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;

    .centerItem {
        width: 48%;
        text-align: center;

        /deep/ .el-upload--text {
            width: 100%;
            height: 100%;
        }

        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }

    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;

        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    line-height: 178px;
    text-align: center;
}
</style>
